import { Switch, TableCell, TableHead, Dialog, Paper } from '@mui/material';
import { Button, rem } from '@innovyze/stylovyze';
import { Check, Close, Delete, Edit, MoreVert } from '@mui/icons-material';
import styled, { css } from 'styled-components';

export const SensorConfigurationsSwitch = styled(Switch)`
	.MuiSwitch-switchBase {
		color: #a5bdc6;
		padding: 9px !important;
		&.Mui-checked {
			color: #00abd1;
			padding: 9px !important;
			position: absolute !important;
		}
		&.MuiSwitch-colorSecondary {
			position: absolute !important;
		}
		&.Mui-checked + .MuiSwitch-track {
			background-color: #a5bdc6;
		}
	}
`;

export const actionStyles = css`
	color: #768d95;
	margin: 0px 10px;
	cursor: pointer;
`;
export const StyledMoreVert = styled(MoreVert)`
	${actionStyles}
`;

export const StyledEdit = styled(Edit)`
	${actionStyles}
`;

export const StyledDelete = styled(Delete)`
	${actionStyles}
`;

export const HeaderCellChkbox = styled(TableCell)`
	color: #4a6067;
	width: 5%;
`;

export const StyledButton = styled(Button)`
	&& {
		color: #ffffff;
		background-color: #007ca0;
		float: right;
	}
`;

export const TableHeader = styled(TableHead)`
	background: #f2f2f2;
`;

export const TableBodyCellChkbox = styled(TableCell)`
	width: 5%;
`;

export const TableActionCell = styled(TableCell)`
	width: 12%;
	text-align: right;
`;

export const StyledCheck = styled(Check)`
	color: #528c05;
	margin: 0px 10px;
`;

export const StyledClose = styled(Close)`
	color: #ae3c1b;
	margin: 0px 10px;
`;

export const StyledModal = styled('div')`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	outline: none;
`;

export const CenteredContent = styled('div')`
	margin: auto;
	text-align: center;
`;

export const PaddingBottomContent = styled('div')`
	padding-bottom: 50px;
`;

export const NoSensorTextContent = styled('div')`
	margin: auto;
	margin-bottom: 15px;
	max-width: 500px;
	color: #90a6ad;
	line-height: 18pt;
`;

export const NoSensorHeader = styled('div')`
	color: #2a2c37;
	font-size: 16pt;
	margin-bottom: 15px;
`;

export const NoSensorImage = styled('img')`
	max-width: 600px;
`;

export const StyledContainer = styled('div')`
	margin: auto;
`;

export const StyledHeaderText = styled.p`
	color: #768d95;
	font-style: normal;
	text-align: right;
`;

export const RightHeader = styled.div`
	display: flex;
	gap: ${rem(16)};
	align-content: center;
	align-items: center;
`;

export const StyledViewChartDialog = styled(Dialog)`
	& .MuiPaper-root {
		overflow-y: visible;
	}
`;

export const StyledViewLocationDialog = styled(Dialog)`
	& .MuiPaper-root {
		overflow-y: visible;
	}
`;

export const ViewChartWrapper = styled(Paper)`
	width: ${rem(800)};
	height: ${rem(472)};
	overflow-y: visible;
`;

export const ViewLocationWrapper = styled(Paper)`
	width: ${rem(800)};
	height: ${rem(472)};
	overflow-y: visible;
`;

export const ChartDialogHeader = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 1.5rem;
	padding-right: 1rem;

	& .MuiSvgIcon-root {
		cursor: pointer;
		color: #a5bdc6;
	}
`;

export const Title = styled.div`
	font-size: ${rem(18)};
	color: #272833;
	font-weight: 600;
	line-height: 24px;
`;
